// src/CcpAdminUsers/EditForm/EditModal.js
import React, { useState } from "react";
import {
  DialogContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../config/firebase";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const EditModal = ({ user, onSuccess, onClose }) => {
  const [name, setName] = useState(user.name);
  const [district, setDistrict] = useState(user.district);
  const [email, setEmail] = useState(user.email);
  const [phone, setPhone] = useState(user.phone);

  // Function to format phone number with dashes as the user types
  const formatPhoneNumber = (input) => {
    // Remove non-numeric characters
    const cleaned = ("" + input).replace(/\D/g, "");

    // Apply phone number formatting
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return input;
  };

  const handlePhoneChange = (e) => {
    // Format phone number as the user types
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };

  const handleSubmit = async () => {
    const userRef = doc(db, "users", user.id);
    await updateDoc(userRef, {
      name,
      district,
      email,
      phone,
    });
    onSuccess();
  };

  return (
    <>
      <ModalDialogTitle onClose={onClose}>Edit User</ModalDialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          autoFocus
          margin="dense"
          label="District"
          type="text"
          fullWidth
          value={district}
          onChange={(e) => setDistrict(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <TextField
          margin="dense"
          label="Phone"
          type="text"
          fullWidth
          value={phone}
          onChange={handlePhoneChange}
        />
      </DialogContent>
      <ModalActions onSave={handleSubmit} />
    </>
  );
};

export default EditModal;
